import api from "@/services/api";
import { PartnerDetailsType } from "@/types/partner/Partner";

const sanitizeString = (value?: string | null): string =>
  value ? value.toString().trim() : "";

const sanitizeOptionalString = (value?: string | null): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  const trimmed = value.toString().trim();
  return trimmed.length ? trimmed : null;
};

const stripNonDigits = (value?: string | null): string =>
  value ? value.toString().replace(/\D/g, "") : "";

class UpdatePartnerStore {
  execute = async (partnerId: string, partner: PartnerDetailsType) => {
    const payload: Record<string, unknown> = {
      name: sanitizeString(partner.name),
      nickname: sanitizeOptionalString(partner.nickname || partner.nickName) || undefined,
      email: sanitizeString(partner.email),
      phone: stripNonDigits(partner.phone),
      document: partner.document?.startsWith("P")
        ? undefined
        : stripNonDigits(partner.document),
      cnaeCode: sanitizeOptionalString(partner.cnaeCode) || undefined,
      categoryId: partner.categoryId ? Number(partner.categoryId) : undefined,
      address: {
        street: sanitizeString(partner.address?.street),
        state: sanitizeString(partner.address?.state),
        addressNumber: sanitizeOptionalString(partner.address?.addressNumber),
        neighborhood: sanitizeString(partner.address?.neighborhood),
        complement: sanitizeOptionalString(partner.address?.complement),
        zipCode: stripNonDigits(partner.address?.zipCode),
        cityName: sanitizeString(partner.address?.cityName),
        ibge: sanitizeString(partner.address?.ibge),
      },
      businessHours: partner.businessHours || [],
      description: partner.description || undefined,
      whatsapp: stripNonDigits(partner.whatsapp) || undefined,
      instagram: sanitizeOptionalString(partner.instagram) || undefined,
    };

    if (Array.isArray(partner.images) && partner.images.length > 0) {
      payload.images = partner.images.map((image) => ({
        image: image.image,
        type: image.type,
      }));
    }

    const response = await api().put(`/partner/${partnerId}/store`, payload);
    return response.data;
  };
}

export { UpdatePartnerStore };
